import { Response } from '@/core'
import { PackageApiBuilder } from './package.api.types'
import {
  ApplyPromoCodeResponse,
  ApplyPromoCodeParams,
  RemovePromoCodeParams,
  RemovePromoCodeResponse,
} from './package.api.promoCode.types'

export const promoCodeEndpoints = (builder: PackageApiBuilder) => ({
  applyPromoCode: builder.mutation<Response<ApplyPromoCodeResponse>, ApplyPromoCodeParams>({
    query: ({ params, data }) => ({
      url: `/package/promo-code/apply`,
      method: 'post',
      params,
      data,
    }),
  }),
  removePromoCode: builder.mutation<Response<RemovePromoCodeResponse>, RemovePromoCodeParams>({
    query: ({ params }) => ({
      url: `/package/promo-code/remove`,
      method: 'delete',
      params,
    }),
  }),
})
